import React from 'react'

function CaseHistory() {
  return (
    <div>CaseHistory</div>
  )
}

export default CaseHistory